<template>
  <div>
    <DialogBase panel-title="Thông tin chung" panel-subtitle="Vui lòng điền đầy đủ thông tin" panel-icon="el-icon-document-add"
        :visible.sync="dialogVisible"
        width="90%"
        :before-close="closeDialog"
        :close-on-click-modal="false"
        top="2vh"
    >
      <el-form
          label-width="140px"
          :model="tabClassMenuInWeekClass"
          label-position="left"
          ref="formAllTabClassMenu"
      >
        <h2 style="margin-top: 10px; display: inline-block">Thực đơn lớp: {{ className }} </h2>
        <el-tabs type="card" @tab-click="handleClick" v-model="activeNameTab">
          <el-tab-pane label="Thứ 2" name="monday">
            <div class="table-content row-data">
              <el-table
                  highlight-current-row
                  :data="tabClassMenuInWeekClass[0].tabClassMenuDayClassList"
                  :header-cell-style="tableHeaderColor"
                  border
              >
                <el-table-column
                    prop="sessionDay"
                    label="Buổi"
                    align="center"
                    width="100"
                ></el-table-column>

                <el-table-column
                    prop="timeContent"
                    label="Thời gian"
                    align="center"
                >
                  <template v-slot:default="scope">
                    <el-input
                        v-model="scope.row.timeContent"
                        placeholder="Nhập thời gian..."
                    ></el-input>
                  </template>
                </el-table-column>

                <el-table-column
                    prop="contentClassMenu"
                    label="Nội dung"
                    align="center"
                >
                  <template v-slot:default="scope">
                    <el-input
                        type="textarea"
                        v-model="scope.row.contentClassMenu"
                        placeholder="Nhập thực đơn..."
                        :rows="4"
                    ></el-input>
                  </template>
                </el-table-column>

                <el-table-column
                    label="Ảnh"
                    align="center"
                    width="200"
                >
                  <template v-slot:default="scope">
                    <div style="display: flex; justify-content: center">
                      <div v-if="scope.row.urlImgMenuWeb" class="container_image">
                        <img :src="scope.row.urlImgMenuWeb" alt="Ảnh minh hoạ"/>
                        <div class="container_image_task ">
                          <span class="btn_delete_image" @click="deleteImageMenu(scope.row, tabClassMenuInWeekClass[0], scope.$index)">
                            <i class="el-icon-close"/>
                          </span>
                        </div>
                      </div>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                    label="Tải ảnh lên"
                    align="center"
                    width="350"
                >
                  <template v-slot:default="scope">
                    <el-upload
                        ref="uploadImageMenu"
                        class="upload_image"
                        action="#"
                        :file-list="fileListImage"
                        list-type="picture-card"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="() => handleRemoveImage(scope, 0)"
                        :on-change="(value) => handleChangeImage(scope, value, 0)"
                        :auto-upload="false"
                        :multiple="false"
                        accept="image/*"
                        :limit="1"
                    >
                      <template #trigger>
                        <div>
                          <i class="el-icon-plus">Thêm ảnh</i>
                        </div>
                      </template>
                    </el-upload>
                  </template>
                </el-table-column>

                <el-table-column
                    v-if="checkPermission(['studentQuality_menu_update'])"
                    label="Tác vụ"
                    align="center"
                    width="120"
                >
                  <template v-slot:default="scope">
                    <div style="display: flex; justify-content: center; align-items: center; gap: 8px;">
                      <el-tooltip effect="dark" content="Xóa" placement="top">
                      <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="deleteRow(scope.$index, 0)"></el-button>
                    </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>

          <el-tab-pane label="Thứ 3" name="tuesday">
            <div class="table-content row-data">
              <el-table
                  highlight-current-row
                  :data="tabClassMenuInWeekClass[1].tabClassMenuDayClassList"
                  :header-cell-style="tableHeaderColor"
                  border
              >
                <el-table-column
                    prop="sessionDay"
                    label="Buổi"
                    align="center"
                    width="100"
                ></el-table-column>
                <el-table-column
                    prop="timeContent"
                    label="Thời gian"
                    align="center"
                >
                  <template v-slot:default="scope">
                    <el-input
                        v-model="scope.row.timeContent"
                        placeholder="Nhập thời gian..."
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="contentClassMenu"
                    label="Nội dung"
                    align="center"
                >
                  <template v-slot:default="scope">
                    <el-input
                        type="textarea"
                        v-model="scope.row.contentClassMenu"
                        placeholder="Nhập thực đơn..."
                        :rows="4"
                    ></el-input>
                  </template>
                </el-table-column>

                <el-table-column
                    label="Ảnh"
                    align="center"
                    width="200"
                >
                  <template v-slot:default="scope">
                    <div style="display: flex; justify-content: center">
                      <div v-if="scope.row.urlImgMenuWeb" class="container_image">
                        <img :src="scope.row.urlImgMenuWeb" alt="Ảnh minh hoạ"/>
                        <div class="container_image_task ">
                          <span class="btn_delete_image" @click="deleteImageMenu(scope.row, tabClassMenuInWeekClass[1], scope.$index)">
                            <i class="el-icon-close"/>
                          </span>
                        </div>
                      </div>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                    label="Tải ảnh lên"
                    align="center"
                    width="350"
                >
                  <template v-slot:default="scope">
                    <el-upload
                        ref="uploadImageMenu"
                        class="upload_image"
                        action="#"
                        :file-list="fileListImage"
                        list-type="picture-card"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="() => handleRemoveImage(scope, 1)"
                        :on-change="(value) => handleChangeImage(scope, value, 1)"
                        :auto-upload="false"
                        :multiple="false"
                        accept="image/*"
                        :limit="1"
                    >
                      <template #trigger>
                        <div>
                          <i class="el-icon-plus">Thêm ảnh</i>
                        </div>
                      </template>
                    </el-upload>
                  </template>
                </el-table-column>

                <el-table-column
                    v-if="checkPermission(['studentQuality_menu_update'])"
                    label="Tác vụ"
                    align="center"
                    width="120"
                >
                  <template v-slot:default="scope">
                    <div style="display: flex; justify-content: center; align-items: center; gap: 8px;">
                      <el-tooltip effect="dark" content="Xóa" placement="top">
                      <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="deleteRow(scope.$index, 1)"></el-button>
                    </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>

          <el-tab-pane label="Thứ 4" name="wednesday">
            <div class="table-content row-data">
              <el-table
                  highlight-current-row
                  :data="tabClassMenuInWeekClass[2].tabClassMenuDayClassList"
                  :header-cell-style="tableHeaderColor"
                  border
              >
                <el-table-column
                    prop="sessionDay"
                    label="Buổi"
                    align="center"
                    width="100"
                ></el-table-column>
                <el-table-column
                    prop="timeContent"
                    label="Thời gian"
                    align="center"
                >
                  <template v-slot:default="scope">
                    <el-input
                        v-model="scope.row.timeContent"
                        placeholder="Nhập thời gian..."
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="contentClassMenu"
                    label="Nội dung"
                    align="center"
                >
                  <template v-slot:default="scope">
                    <el-input
                        type="textarea"
                        v-model="scope.row.contentClassMenu"
                        placeholder="Nhập thực đơn..."
                        :rows="4"
                    ></el-input>
                  </template>
                </el-table-column>

                <el-table-column
                    label="Ảnh"
                    align="center"
                    width="200"
                >
                  <template v-slot:default="scope">
                    <div style="display: flex; justify-content: center">
                      <div v-if="scope.row.urlImgMenuWeb" class="container_image">
                        <img :src="scope.row.urlImgMenuWeb" alt="Ảnh minh hoạ"/>
                        <div class="container_image_task ">
                          <span class="btn_delete_image" @click="deleteImageMenu(scope.row, tabClassMenuInWeekClass[2], scope.$index)">
                            <i class="el-icon-close"/>
                          </span>
                        </div>
                      </div>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                    label="Tải ảnh lên"
                    align="center"
                    width="350"
                >
                  <template v-slot:default="scope">
                    <el-upload
                        ref="uploadImageMenu"
                        class="upload_image"
                        action="#"
                        :file-list="fileListImage"
                        list-type="picture-card"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="() => handleRemoveImage(scope, 2)"
                        :on-change="(value) => handleChangeImage(scope, value, 2)"
                        :auto-upload="false"
                        :multiple="false"
                        accept="image/*"
                        :limit="1"
                    >
                      <template #trigger>
                        <div>
                          <i class="el-icon-plus">Thêm ảnh</i>
                        </div>
                      </template>
                    </el-upload>
                  </template>
                </el-table-column>

                <el-table-column
                    v-if="checkPermission(['studentQuality_menu_update'])"
                    label="Tác vụ"
                    align="center"
                    width="120"
                >
                  <template v-slot:default="scope">
                    <div style="display: flex; justify-content: center; align-items: center; gap: 8px;">
                      <el-tooltip effect="dark" content="Xóa" placement="top">
                      <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="deleteRow(scope.$index, 2)"></el-button>
                    </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>

          <el-tab-pane label="Thứ 5" name="thursday">
            <div class="table-content row-data">
              <el-table
                  highlight-current-row
                  :data="tabClassMenuInWeekClass[3].tabClassMenuDayClassList"
                  :header-cell-style="tableHeaderColor"
                  border
              >
                <el-table-column
                    prop="sessionDay"
                    label="Buổi"
                    align="center"
                    width="100"
                ></el-table-column>
                <el-table-column
                    prop="timeContent"
                    label="Thời gian"
                    align="center"
                >
                  <template v-slot:default="scope">
                    <el-input
                        v-model="scope.row.timeContent"
                        placeholder="Nhập thời gian..."
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="contentClassMenu"
                    label="Nội dung"
                    align="center"
                >
                  <template v-slot:default="scope">
                    <el-input
                        type="textarea"
                        v-model="scope.row.contentClassMenu"
                        placeholder="Nhập thực đơn..."
                        :rows="4"
                    ></el-input>
                  </template>
                </el-table-column>

                <el-table-column
                    label="Ảnh"
                    align="center"
                    width="200"
                >
                  <template v-slot:default="scope">
                    <div style="display: flex; justify-content: center">
                      <div v-if="scope.row.urlImgMenuWeb" class="container_image">
                        <img :src="scope.row.urlImgMenuWeb" alt="Ảnh minh hoạ"/>
                        <div class="container_image_task ">
                          <span class="btn_delete_image" @click="deleteImageMenu(scope.row, tabClassMenuInWeekClass[3], scope.$index)">
                            <i class="el-icon-close"/>
                          </span>
                        </div>
                      </div>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                    label="Tải ảnh lên"
                    align="center"
                    width="350"
                >
                  <template v-slot:default="scope">
                    <el-upload
                        ref="uploadImageMenu"
                        class="upload_image"
                        action="#"
                        :file-list="fileListImage"
                        list-type="picture-card"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="() => handleRemoveImage(scope, 3)"
                        :on-change="(value) => handleChangeImage(scope, value, 3)"
                        :auto-upload="false"
                        :multiple="false"
                        accept="image/*"
                        :limit="1"
                    >
                      <template #trigger>
                        <div>
                          <i class="el-icon-plus">Thêm ảnh</i>
                        </div>
                      </template>
                    </el-upload>
                  </template>
                </el-table-column>

                <el-table-column
                    v-if="checkPermission(['studentQuality_menu_update'])"
                    label="Tác vụ"
                    align="center"
                    width="120"
                >
                  <template v-slot:default="scope">
                    <div style="display: flex; justify-content: center; align-items: center; gap: 8px;">
                      <el-tooltip effect="dark" content="Xóa" placement="top">
                      <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="deleteRow(scope.$index, 3)"></el-button>
                    </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>

          <el-tab-pane label="Thứ 6" name="friday">
            <div class="table-content row-data">
              <el-table
                  highlight-current-row
                  :data="tabClassMenuInWeekClass[4].tabClassMenuDayClassList"
                  :header-cell-style="tableHeaderColor"
                  border
              >
                <el-table-column
                    prop="sessionDay"
                    label="Buổi"
                    align="center"
                    width="100"
                ></el-table-column>
                <el-table-column
                    prop="timeContent"
                    label="Thời gian"
                    align="center"
                >
                  <template v-slot:default="scope">
                    <el-input
                        v-model="scope.row.timeContent"
                        placeholder="Nhập thời gian..."
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="contentClassMenu"
                    label="Nội dung"
                    align="center"
                >
                  <template v-slot:default="scope">
                    <el-input
                        type="textarea"
                        v-model="scope.row.contentClassMenu"
                        placeholder="Nhập thực đơn..."
                        :rows="4"
                    ></el-input>
                  </template>
                </el-table-column>

                <el-table-column
                    label="Ảnh"
                    align="center"
                    width="200"
                >
                  <template v-slot:default="scope">
                    <div style="display: flex; justify-content: center">
                      <div v-if="scope.row.urlImgMenuWeb" class="container_image">
                        <img :src="scope.row.urlImgMenuWeb" alt="Ảnh minh hoạ"/>
                        <div class="container_image_task ">
                          <span class="btn_delete_image" @click="deleteImageMenu(scope.row, tabClassMenuInWeekClass[4], scope.$index)">
                            <i class="el-icon-close"/>
                          </span>
                        </div>
                      </div>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                    label="Tải ảnh lên"
                    align="center"
                    width="350"
                >
                  <template v-slot:default="scope">
                    <el-upload
                        ref="uploadImageMenu"
                        class="upload_image"
                        action="#"
                        :file-list="fileListImage"
                        list-type="picture-card"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="() => handleRemoveImage(scope, 4)"
                        :on-change="(value) => handleChangeImage(scope, value, 4)"
                        :auto-upload="false"
                        :multiple="false"
                        accept="image/*"
                        :limit="1"
                    >
                      <template #trigger>
                        <div>
                          <i class="el-icon-plus">Thêm ảnh</i>
                        </div>
                      </template>
                    </el-upload>
                  </template>
                </el-table-column>

                <el-table-column
                    v-if="checkPermission(['studentQuality_menu_update'])"
                    label="Tác vụ"
                    align="center"
                    width="120"
                >
                  <template v-slot:default="scope">
                    <div style="display: flex; justify-content: center; align-items: center; gap: 8px;">
                      <el-tooltip effect="dark" content="Xóa" placement="top">
                      <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="deleteRow(scope.$index, 4)"></el-button>
                    </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>

          <el-tab-pane label="Thứ 7" name="saturday">
            <div class="table-content row-data">
              <el-table
                  highlight-current-row
                  :data="tabClassMenuInWeekClass[5].tabClassMenuDayClassList"
                  :header-cell-style="tableHeaderColor"
                  border
              >
                <el-table-column
                    prop="sessionDay"
                    label="Buổi"
                    align="center"
                    width="100"
                ></el-table-column>
                <el-table-column
                    prop="timeContent"
                    label="Thời gian"
                    align="center"
                >
                  <template v-slot:default="scope">
                    <el-input
                        v-model="scope.row.timeContent"
                        placeholder="Nhập thời gian..."
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="contentClassMenu"
                    label="Nội dung"
                    align="center"
                >
                  <template v-slot:default="scope">
                    <el-input
                        type="textarea"
                        v-model="scope.row.contentClassMenu"
                        placeholder="Nhập thực đơn..."
                        :rows="4"
                    ></el-input>
                  </template>
                </el-table-column>

                <el-table-column
                    label="Ảnh"
                    align="center"
                    width="200"
                >
                  <template v-slot:default="scope">
                    <div style="display: flex; justify-content: center">
                      <div v-if="scope.row.urlImgMenuWeb" class="container_image">
                        <img :src="scope.row.urlImgMenuWeb" alt="Ảnh minh hoạ"/>
                        <div class="container_image_task ">
                          <span class="btn_delete_image" @click="deleteImageMenu(scope.row, tabClassMenuInWeekClass[5], scope.$index)">
                            <i class="el-icon-close"/>
                          </span>
                        </div>
                      </div>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                    label="Tải ảnh lên"
                    align="center"
                    width="350"
                >
                  <template v-slot:default="scope">
                    <el-upload
                        ref="uploadImageMenu"
                        class="upload_image"
                        action="#"
                        :file-list="fileListImage"
                        list-type="picture-card"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="() => handleRemoveImage(scope, 5)"
                        :on-change="(value) => handleChangeImage(scope, value, 5)"
                        :auto-upload="false"
                        :multiple="false"
                        accept="image/*"
                        :limit="1"
                    >
                      <template #trigger>
                        <div>
                          <i class="el-icon-plus">Thêm ảnh</i>
                        </div>
                      </template>
                    </el-upload>
                  </template>
                </el-table-column>

                <el-table-column
                    v-if="checkPermission(['studentQuality_menu_update'])"
                    label="Tác vụ"
                    align="center"
                    width="120"
                >
                  <template v-slot:default="scope">
                    <div style="display: flex; justify-content: center; align-items: center; gap: 8px;">
                      <el-tooltip effect="dark" content="Xóa" placement="top">
                      <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="deleteRow(scope.$index, 5)"></el-button>
                    </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-form>
      <template #footer>
      <div class="tab-infor-button">
        <el-button
            type="danger"
            size="medium"
            @click="closeDialogByButton('formAllTabClassMenu')"
        >
          <i class="el-icon-circle-close"/>
          <span>Đóng</span>
        </el-button>
        <el-button
            v-if="checkPermission(['studentQuality_menu_update'])"
            type="success"
            size="medium"
            :loading="loadingButton"
            mini
            @click="submitForm('formAllTabClassMenu')"
        >
          <i class="el-icon-circle-check"/>
          <span>Lưu</span>
        </el-button>
      </div>
      </template>
    </DialogBase>
  </div>
</template>

<script>
import DialogBase from "@/components/DialogBase.vue";
import checkPermission from "@/utils/permission.js";
import ClassMenuService from "../../services/ClassMenuService";

export default {
  components: { DialogBase },
  props: {
    dialogVisible: null,
  },
  data() {
    return {
      src: "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
      fileListImage: [],
      containerImageFile: [
        {
          listImageFile: []
        },
        {
          listImageFile: []
        },
        {
          listImageFile: []
        },
        {
          listImageFile: []
        },
        {
          listImageFile: []
        },
        {
          listImageFile: []
        },
        {
          listImageFile: []
        },
      ],
      timeSchedule: "",
      className: "",
      tabDayInWeek: [],
      tabAllDayInWeek: [],
      tabClassMenuInWeekClass: [
        {
          tabClassMenuDayClassList: [
            {
              sessionDay: "Sáng",
              timeContent: "",
              contentClassMenu: "",
              urlImgMenuWeb: "",
            },
            {
              sessionDay: "Phụ Sáng",
              timeContent: "",
              contentClassMenu: "",
              urlImgMenuWeb: "",
            },
            {
              sessionDay: "Trưa",
              timeContent: "",
              contentClassMenu: "",
              urlImgMenuWeb: "",
            },
            {
              sessionDay: "Chiều",
              timeContent: "",
              contentClassMenu: "",
              urlImgMenuWeb: "",
            },
            {
              sessionDay: "Phụ Chiều",
              timeContent: "",
              contentClassMenu: "",
              urlImgMenuWeb: "",
            },
            {
              sessionDay: "Tối",
              timeContent: "",
              contentClassMenu: "",
              urlImgMenuWeb: "",
            },
          ],
        },
        {
          tabClassMenuDayClassList: [
            {
              sessionDay: "Sáng",
              timeContent: "",
              contentClassMenu: "",
              urlImgMenuWeb: "",
            },
            {
              sessionDay: "Phụ Sáng",
              timeContent: "",
              contentClassMenu: "",
              urlImgMenuWeb: "",
            },
            {
              sessionDay: "Trưa",
              timeContent: "",
              contentClassMenu: "",
              urlImgMenuWeb: "",
            },
            {
              sessionDay: "Chiều",
              timeContent: "",
              contentClassMenu: "",
              urlImgMenuWeb: "",
            },
            {
              sessionDay: "Phụ Chiều",
              timeContent: "",
              contentClassMenu: "",
              urlImgMenuWeb: "",
            },
            {
              sessionDay: "Tối",
              timeContent: "",
              contentClassMenu: "",
              urlImgMenuWeb: "",
            },
          ],
        },
        {
          tabClassMenuDayClassList: [
            {
              sessionDay: "Sáng",
              timeContent: "",
              contentClassMenu: "",
              urlImgMenuWeb: "",
            },
            {
              sessionDay: "Phụ Sáng",
              timeContent: "",
              contentClassMenu: "",
              urlImgMenuWeb: "",
            },
            {
              sessionDay: "Trưa",
              timeContent: "",
              contentClassMenu: "",
              urlImgMenuWeb: "",
            },
            {
              sessionDay: "Chiều",
              timeContent: "",
              contentClassMenu: "",
              urlImgMenuWeb: "",
            },
            {
              sessionDay: "Phụ Chiều",
              timeContent: "",
              contentClassMenu: "",
              urlImgMenuWeb: "",
            },
            {
              sessionDay: "Tối",
              timeContent: "",
              contentClassMenu: "",
              urlImgMenuWeb: "",
            },
          ],
        },
        {
          tabClassMenuDayClassList: [
            {
              sessionDay: "Sáng",
              timeContent: "",
              contentClassMenu: "",
              urlImgMenuWeb: "",
            },
            {
              sessionDay: "Phụ Sáng",
              timeContent: "",
              contentClassMenu: "",
              urlImgMenuWeb: "",
            },
            {
              sessionDay: "Trưa",
              timeContent: "",
              contentClassMenu: "",
              urlImgMenuWeb: "",
            },
            {
              sessionDay: "Chiều",
              timeContent: "",
              contentClassMenu: "",
              urlImgMenuWeb: "",
            },
            {
              sessionDay: "Phụ Chiều",
              timeContent: "",
              contentClassMenu: "",
              urlImgMenuWeb: "",
            },
            {
              sessionDay: "Tối",
              timeContent: "",
              contentClassMenu: "",
              urlImgMenuWeb: "",
            },
          ],
        },
        {
          tabClassMenuDayClassList: [
            {
              sessionDay: "Sáng",
              timeContent: "",
              contentClassMenu: "",
              urlImgMenuWeb: "",
            },
            {
              sessionDay: "Phụ Sáng",
              timeContent: "",
              contentClassMenu: "",
              urlImgMenuWeb: "",
            },
            {
              sessionDay: "Trưa",
              timeContent: "",
              contentClassMenu: "",
              urlImgMenuWeb: "",
            },
            {
              sessionDay: "Chiều",
              timeContent: "",
              contentClassMenu: "",
              urlImgMenuWeb: "",
            },
            {
              sessionDay: "Phụ Chiều",
              timeContent: "",
              contentClassMenu: "",
              urlImgMenuWeb: "",
            },
            {
              sessionDay: "Tối",
              timeContent: "",
              contentClassMenu: "",
              urlImgMenuWeb: "",
            },
          ],
        },
        {
          tabClassMenuDayClassList: [
            {
              sessionDay: "Sáng",
              timeContent: "",
              contentClassMenu: "",
              urlImgMenuWeb: "",
            },
            {
              sessionDay: "Phụ Sáng",
              timeContent: "",
              contentClassMenu: "",
              urlImgMenuWeb: "",
            },
            {
              sessionDay: "Trưa",
              timeContent: "",
              contentClassMenu: "",
              urlImgMenuWeb: "",
            },
            {
              sessionDay: "Chiều",
              timeContent: "",
              contentClassMenu: "",
              urlImgMenuWeb: "",
            },
            {
              sessionDay: "Phụ Chiều",
              timeContent: "",
              contentClassMenu: "",
              urlImgMenuWeb: "",
            },
            {
              sessionDay: "Tối",
              timeContent: "",
              contentClassMenu: "",
              urlImgMenuWeb: "",
            },
          ],
        },
        {
          tabClassMenuDayClassList: [
            {
              sessionDay: "Sáng",
              timeContent: "",
              contentClassMenu: "",
              urlImgMenuWeb: "",
            },
            {
              sessionDay: "Phụ Sáng",
              timeContent: "",
              contentClassMenu: "",
              urlImgMenuWeb: "",
            },
            {
              sessionDay: "Trưa",
              timeContent: "",
              contentClassMenu: "",
              urlImgMenuWeb: "",
            },
            {
              sessionDay: "Chiều",
              timeContent: "",
              contentClassMenu: "",
              urlImgMenuWeb: "",
            },
            {
              sessionDay: "Phụ Chiều",
              timeContent: "",
              contentClassMenu: "",
              urlImgMenuWeb: "",
            },
            {
              sessionDay: "Tối",
              timeContent: "",
              contentClassMenu: "",
              urlImgMenuWeb: "",
            },
          ],
        },
      ],
    };
  },
  methods: {
    checkPermission,
    deleteRow(index, day) {
      let a = this.tabClassMenuInWeekClass[day].tabClassMenuDayClassList[index];
      a.contentClassMenu = "";
      a.timeContent = "";
    },
    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff;font-weight: bold;border:1px solid #fff";
    },
    closeDialog(done) {
      if (this.$refs["formAllTabClassMenu"]) {
        this.$refs["formAllTabClassMenu"].resetFields();
      }
      this.$emit("dialog-close");
      if (typeof done === "function") {
        done();
      }
    },
    //click when click button
    closeDialogByButton(fromData) {
      this.$refs[fromData].resetFields();
      this.$emit("dialog-close");
      this.resetUploadImageMenu();
    },
    handleClose(done) {
      this.$confirm("Are you sure to close this dialog?")
          .then((_) => {
            console.log(_);
            done();
          })
          .catch((_) => {
            console.log(_);
          });
    },
    // submitForm(fromData) {
    //   let a = this.tabClassMenuInWeekClass;
    //   console.log(a);
    //   this.$refs[fromData].validate((valid) => {
    //     if (valid) {
    //       ClassMenuService.createClassMenuInClassInWeek(
    //           this.tabClassMenuInWeekClass
    //       )
    //           .then((response) => {
    //             console.log(response.data.data);
    //             this.$message({
    //               message: "Thêm mới thực đơn thành công",
    //               type: "success",
    //             });
    //             setTimeout(() => {
    //               this.closeDialogByButton(fromData);
    //             }, 500);
    //           })
    //           .catch((err) => {
    //             this.$message({
    //               message: "Thêm mới thực đơn thất bại",
    //               type: "error",
    //             });
    //
    //             console.log(err);
    //           })
    //           .finally(() => {
    //             setTimeout(() => {
    //               this.loadingButton = false;
    //             }, 500);
    //           });
    //     } else {
    //       console.log("error validate data!");
    //       return false;
    //     }
    //   });
    // },

    submitForm(fromData) {
      this.$refs[fromData].validate((valid) => {
        if (valid) {
          ClassMenuService.createMenuClass(
              this.appendFormData()
          )
              .then(() => {
                this.$message({
                  message: "Thêm mới thực đơn thành công",
                  type: "success",
                });
                setTimeout(() => {
                  this.closeDialogByButton(fromData);
                }, 500);
              })
              .catch((err) => {
                this.$message({
                  message: "Thêm mới thực đơn thất bại",
                  type: "error",
                });
                console.log(err);
              })
              .finally(() => {
                setTimeout(() => {
                  this.loadingButton = false;
                }, 500);

                this.resetContainerFileImage();
              });
        } else {
          console.log("error validate data!");
          return false;
        }
      });
    },

    appendFormData() {
      const formData = new FormData();
      const data = this.tabClassMenuInWeekClass;

      data.forEach((tabClassMenu, classIndex) => {
        const listDataInDay = this.containerImageFile[classIndex];

        formData.append(`tabClassMenuByIdClassInWeekList[${classIndex}].idClass`, tabClassMenu.idClass);
        formData.append(`tabClassMenuByIdClassInWeekList[${classIndex}].timeClassMenu`, tabClassMenu.timeClassMenu);
        if (tabClassMenu.idClassMenu !== null) {
          formData.append(`tabClassMenuByIdClassInWeekList[${classIndex}].idClassMenu`, tabClassMenu.idClassMenu);
        }

        tabClassMenu.tabClassMenuDayClassList.forEach((dayMenu, dayIndex) => {
          const dataFile = this.findDataFileImage(listDataInDay.listImageFile, dayIndex);
          formData.append(`tabClassMenuByIdClassInWeekList[${classIndex}].tabClassMenuDayClassList[${dayIndex}].sessionDay`, dayMenu.sessionDay);

          if (dayMenu.timeContent) {
            formData.append(`tabClassMenuByIdClassInWeekList[${classIndex}].tabClassMenuDayClassList[${dayIndex}].timeContent`, dayMenu.timeContent);
          }

          if (dayMenu.contentClassMenu) {
            formData.append(`tabClassMenuByIdClassInWeekList[${classIndex}].tabClassMenuDayClassList[${dayIndex}].contentClassMenu`, dayMenu.contentClassMenu);
          }

          if (dataFile) {
            formData.append(`tabClassMenuByIdClassInWeekList[${classIndex}].tabClassMenuDayClassList[${dayIndex}].multipartFile`, dataFile.value?.raw);
          }
        });
      });

      return formData;
    },

    getClassMenuByIdClass(timeSchedule, idClass, timeDay, className) {
      this.className = className;
      this.timeSchedule = timeSchedule;
      if (timeDay === 2) {
        this.activeNameTab = "monday";
      }
      if (timeDay === 3) {
        this.activeNameTab = "tuesday";
      }
      if (timeDay === 4) {
        this.activeNameTab = "wednesday";
      }
      if (timeDay === 5) {
        this.activeNameTab = "thursday";
      }
      if (timeDay === 6) {
        this.activeNameTab = "friday";
      }
      if (timeDay === 7) {
        this.activeNameTab = "saturday";
      }
      if (timeDay === 8) {
        this.activeNameTab = "sunday";
      }
      ClassMenuService.getClassMenuByIdClass(timeSchedule, idClass)
          .then((res) => {
            this.tabClassMenuInWeekClass = res.data.data;
          })
          .catch((e) => {
            console.log(e);
          });
    },

    handleChangeImage(scope, value, index) {
      const data = {
        index: scope.$index,
        value: value,
      }
      this.containerImageFile[index].listImageFile.push(data);
    },

    handleRemoveImage(scope, index) {
      const i = this.containerImageFile[index].listImageFile.findIndex(item => item.index === scope.$index);

      if (i !== -1) {
        this.containerImageFile[index].listImageFile.splice(i, 1);
      }
    },

    resetUploadImageMenu() {
      this.fileListImage = [];
      this.$refs.uploadImageMenu.clearFiles();
    },

    findDataFileImage(dataArray, index) {
      return dataArray.find(item => item.index === index);
    },

    resetContainerFileImage() {
      const data = this.containerImageFile;

      data.forEach((item) => {
        item.listImageFile = [];
      })
    },

    deleteImageMenu(row, tabClassMenu, index) {
      this.$confirm("Bạn có chắc chắn muốn xóa ảnh?", "Thông báo!", {
        distinguishCancelAndClose: true,
        confirmButtonText: "Có",
        closeOnClickModal: false,
        cancelButtonText: "Không",
      }).then(() => {
        ClassMenuService.deleteImageMenu(tabClassMenu.idClassMenu, row.sessionDay)
            .then((res) => {
              tabClassMenu.tabClassMenuDayClassList[index].urlImgMenuWeb = "";
              this.$message({
                message: res.data.message,
                type: "success",
              });
            })
            .catch((err) => {
              console.log(err);
            })
      })
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/sk-dialog.scss";
/deep/ .el-dialog__title {
  font-size: 25px;
  color: #606266;
}

/deep/ .el-form-item__label {
  font-family: Arial, Helvetica, sans-serif;
}

/deep/ .el-button--primary {
  width: 100%;
  background: #409eff;
}

/deep/ .upload-demo {
  text-align: center;

  .el-upload {
    width: 100%;
  }
}

/deep/ .el-avatar {
  display: inline;

  img {
    border-radius: 5px;
    width: 100%;
  }
}

/deep/ .el-input.is-disabled .el-input__inner {
  text-align: center;
  color: #d13b93;
  font-weight: bold;
}

.el-select {
  display: block;
}

.tab-infor-button {
  text-align: right;
  margin-top: 20px;
}

.bg-purple {
  background: #d3dce6;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.group-radio-status {
  margin: 0 50px;

  .kids-status {
    margin-bottom: 10px;
  }
}

// /deep/.el-tabs__nav {
//   background: #a0a19ce0;
// }
// /deep/.el-tabs__item {
//   color: white;
// }
// /deep/.el-tabs__item.is-active {
//   color: white;
//   background: #67c23a;
// }
/deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:after {
  content: "*";
  color: #f56c6c;
  margin-left: 3px;
}

/deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
  content: "";
  color: #f56c6c;
  margin-left: -4px;
}

.table-icon-1 {
  width: 30%;
  margin-left: 15%;
  display: inline-block;
}

.table-icon-2 {
  width: 30%;
  margin-right: 15%;
  float: right;
}

.wrap_image_menu {
  display: flex;
}

.container_image {
  position: relative;
  width: 146px;
  height: 146px;
  border: 1px solid #ccc;
  border-radius: 6px;
  display: flex;

  img {
    width: 100%;
    object-fit: cover;
    border-radius: 6px;
  }

  .container_image_task {
    position: absolute;
    top: 4px;
    right: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    border-radius: 50%;
    transition: all 0.5s ease-in;
    width: 20px;
    height: 20px;
    border: 1px solid #ccc;

    &:hover {
      background-color: #ccc;
      .btn_delete_image {
        color: #fff;
      }
    }

    .btn_delete_image {
      display: block;
      font-size: 16px;
      color: #939393;
      transition: all 0.5s ease-in;
      cursor: pointer;

    }
  }
}
</style>
